<template>
    <el-row>
        <el-col :span="20" :offset="2">
            <el-row>
                <el-col :span="12">
                    <h1 align="left">CS Performance</h1>
                </el-col>
                <el-col :span="12"  align="right">
                    <el-date-picker
                        v-model="date"
                        @change="filterByDate"
                        type="date"
                        style="margin-top: 12px;"
                        placeholder="Pick a day"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-table
                ref="OrderList"
                :data="allCsPerformance"
                :header-cell-style="{
                    'background-color': 'black',
                    color: 'white'
                }"
                style="width: 100%; margin-top: 10px;"
                v-loading="loading"
            >
                <el-table-column label="Email" width=""
                ><template slot-scope="scope">
                    {{ scope.row.email }}</template
                ></el-table-column
                >
                <el-table-column label="All Case" width="100"
                ><template >
                    {{  }}</template
                ></el-table-column
                >
                <el-table-column label="Flag" width="100"
                ><template slot-scope="scope">
                    {{ scope.row.flag }}</template
                ></el-table-column
                >
                <el-table-column label="Flag Done" width="100"
                ><template slot-scope="scope">
                    {{ scope.row.flag_done }}</template
                ></el-table-column
                >
                <el-table-column label="Line" width="100"
                ><template slot-scope="scope">
                    {{ scope.row.line }}</template
                ></el-table-column
                >
                <el-table-column label="Line Done" width="100"
                ><template slot-scope="scope">
                    {{ scope.row.line_done }}</template
                ></el-table-column
                >
                <el-table-column label="All Done" width="100"
                ><template slot-scope="scope">
                    {{ scope .row.all_done}}</template
                ></el-table-column
                >
                <el-table-column label="All Left" width="100"
                ><template slot-scope="scope">
                    {{ scope.row.all_left }}</template
                ></el-table-column
                >
            </el-table>

            <el-col style="margin-top:10px;">
                <el-pagination
                @size-change="changeLimitPage"
                @current-change="changeCurrentPage"
                :current-page.sync="pagination.currentPage"
                :page-sizes="pagination.pageSizes"
                :page-size="10"
                layout="prev, pager, next, sizes"
                :total="pagination.allPage * pagination.limit"
                ></el-pagination>
            </el-col>

        </el-col>
    </el-row>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'CsPerformance',
    data () {
        return {
            loading: false,
            date: '',
            allCsPerformance: [],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }
        }
    },
    created () {
        this.getdata()
    },
    methods: {
        async getdata () {
            var customerCsList = await fgApi.caseTracking.getListCsPerformance(this.pagination.limit, this.pagination.offset, this.date)
            this.allCsPerformance = customerCsList.data.result
            this.pagination.allPage = customerCsList.data.all_page
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.getdata()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.getdata()
        },
        filterByDate () {
            console.log(this.date)
            let date = JSON.stringify(this.date)
            this.date = date.slice(1, 11)
            this.getdata()
            console.log(this.date)
        }
    }
}
</script>
